import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { IUser } from 'src/app/shared/interfaces/user.interface';
import { IItemWishList } from 'src/app/shared/interfaces/custom-item-wish-list';
import { CustomProductCardEnt } from 'src/app/shared/interfaces/custom-product-card-ent';
import { WishList } from 'src/app/utils/functions/wishList';

@Component({
  selector: 'app-shopping-car-modal',
  templateUrl: './shopping-car-modal.component.html'
})
export class ShoppingCarModalComponent implements OnChanges, OnInit {
  @Input() visible: boolean = false;
  @Input() product: CustomProductCardEnt = new CustomProductCardEnt();
  @Output() noVisible = new EventEmitter<boolean>();
  openModalMakeOrder: boolean = false;
  item: IItemWishList = new IItemWishList();
  numItem: number = 0;
  totPriceWishList: number = 0;
  address?: string = '';

  constructor(
    private wishList: WishList
  ) {}

  ngOnInit(): void {
    this.item = this.wishList.getItemWishList(this.product);

    const localData = localStorage.getItem('user');
    if(localData) {
      let user: IUser = JSON.parse(localData);
    this.address = user.address;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.item = this.wishList.getItemWishList(this.product);
    this.numItem = this.wishList.countForItems();
    this.totPriceWishList = this.wishList.totPriceWishList();
  }

  showDialog() {
    this.visible = true;
  }

  makeOrderLocalStorage() {
    localStorage.setItem('goToOrder', 'true')
  }

  onDialogClose(){
    this.visible = false;
    this.noVisible.emit(this.visible);
  }

  makeOrder(){
    this.visible = false;
    this.openModalMakeOrder = true;
  }

  closeMakeOrder(){
    this.openModalMakeOrder = false;
  }

  showPrice() {
    return this.item.product.isOnDiscount
      ? this.item.product.priceDiscount
      : this.item.product.price
  }
}
